import React from "react";
import { Card } from "../card";
import { ChildrenCards } from "./ChildrenCards";
import { useGetMyChild } from "../../hooks/parentsHooks/useParents.hooks";

export const MyChildren = () => {
  const { isLoading: isChildLoading, data: childDatas } = useGetMyChild();

  if (isChildLoading) {
    return <></>;
  }
  return (
    <>
      <Card cardTitle="My Children">
        {(childDatas || []).map((childInfo: any) => {
          return (
            <div className="flex">
              <div className="flex-1 pt-4">
                <ChildrenCards kidsInfo={childInfo} />
              </div>
            </div>
          );
        })}
      </Card>
    </>
  );
};
